import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import ic_date from 'assets/images/ic_date.svg';

import { Datepicker } from "components";

import { func_validation, isStringTrimNotEmpty } from 'functions';

import "assets/scss/components/form/dateRangePicker.scss";




export function DateRangePicker(props) {
    const { 
        className, 

        labelWrapperClassName,
        label,
        isLabelRequired,

        inputWrapperClassName,

        startClassName,
        defaultDate_start,
        placeholder_start,
        startDateOptions,

        endClassName,
        defaultDate_end,
        placeholder_end, 
        endDateOptions,

        isResetRequired, isInputRequired, isSideIconVisible,
        isFormatConversionRequired_fromDDMMYYYY, isConversionRequired_ISO8601
    } = props;

    // Date Conversion
    function convertDateFormat(date) {
        let dateConverted = date;
        if (isFormatConversionRequired_fromDDMMYYYY &&
            func_validation.isStringTrimNotEmpty(date)) {
    
            let dateValues = date.split("/");
            dateConverted = dateValues[1] + "/" + dateValues[0] + "/" + dateValues[2];
        }
    
        let dateFormatted = func_validation.isStringTrimNotEmpty(dateConverted)? new Date(dateConverted): "";
        return dateFormatted;
    }
    
    // Validate Props
    let defaultDate_start_validated = convertDateFormat(defaultDate_start);
    let placeholder_start_validated = func_validation.isStringTrimNotEmpty(placeholder_start)? placeholder_start:"Start Date";
    let defaultDate_end_validated = convertDateFormat(defaultDate_end);
    let placeholder_end_validated = func_validation.isStringTrimNotEmpty(placeholder_end)? placeholder_end:"End Date";

    // States
    const [startDate, setStartDate] = useState(defaultDate_start_validated);
    const [endDate, setEndDate] = useState(defaultDate_end_validated);

    // Reset
    useEffect(() => {
        if (isResetRequired) {
            setStartDate(defaultDate_start_validated);
            setEndDate(defaultDate_end_validated);
        }
    }, [isResetRequired])

    function handleOnChange_start(date) {
        setStartDate(date);

        if (props.handleOnChange_start)
            props.handleOnChange_start(date);
    }

    function handleOnChange_end(date) {
        setEndDate(date);

        if (props.handleOnChange_end)
            props.handleOnChange_end(date);
    }

    return (
        <div className={"component-date-range-picker " +
                (className? className + " ":"")}>

            {/* Label */}
            {isLabelRequired && isStringTrimNotEmpty(label)? (
                <div className={"component-date-range-picker__label-wrapper " + 
                        (labelWrapperClassName? labelWrapperClassName + " ":"")}
                >
                    <span className={"label-wrapper__label"}>{label}</span>
                    {isInputRequired? (<span className={"label-wrapper__required-symbol"}>*</span>):""}
                </div>
            ):""}
            
            {/* Input */}
            <div className={"component-date-range-picker__input-wrapper d-flex align-items-center " +
                    (inputWrapperClassName? inputWrapperClassName + " ":"")}
            >
                {/* Start */}
                <Datepicker
                    className={"input-wrapper__start flex-fill"}
                    inputClassName={"start__input text-center " +
                        (startClassName? startClassName + " ":"")}
                    defaultDate={defaultDate_start_validated}

                    placeholderClassName={"start__placeholder text-center"}
                    placeholder={placeholder_start_validated}

                    handleOnChange={handleOnChange_start}
                    handleOnEmptyInput={props.handleOnEmptyInput_start}

                    otherOptions={{
                        startDate: startDate? new Date(startDate):undefined,
                        endDate: endDate? new Date(endDate):undefined,
                        selectsStart: true,
                    }}

                    isResetRequired={isResetRequired}

                    isFormatConversionRequired_fromDDMMYYYY={isFormatConversionRequired_fromDDMMYYYY}
                    isConversionRequired_ISO8601={isConversionRequired_ISO8601}
                    isSideIconHidden

                    {...startDateOptions}
                />

                {/* Arrow */}
                <div className="input-wrapper__arrow">
                    <FontAwesomeIcon 
                        className={"arrow__icon"} 
                        icon={faArrowRight}
                    />
                </div>

                {/* End */}
                <Datepicker
                    className={"input-wrapper__end flex-fill"}
                    inputClassName={"end__input text-center " +
                        (endClassName? endClassName + " ":"")}
                    defaultDate={defaultDate_end_validated}

                    placeholderClassName={"end__placeholder text-center"}
                    placeholder={placeholder_end_validated}

                    handleOnChange={handleOnChange_end}
                    handleOnEmptyInput={props.handleOnEmptyInput_end}

                    otherOptions={{
                        startDate: startDate? new Date(startDate):undefined,
                        endDate: endDate? new Date(endDate):undefined,
                        minDate: startDate? new Date(startDate):undefined,
                        selectsEnd: true,
                    }}

                    isResetRequired={isResetRequired}

                    isFormatConversionRequired_fromDDMMYYYY={isFormatConversionRequired_fromDDMMYYYY}
                    isConversionRequired_ISO8601={isConversionRequired_ISO8601}
                    isSideIconHidden

                    {...endDateOptions}
                />

                {/* Side Icon */}
                {(isSideIconVisible)? (
                    <img
                        className={"input-wrapper__side-icon"}
                        src={ic_date}
                        alt={"Side Icon"}
                    />
                ):""}
            </div>
        </div>
    )
}